import React, { useEffect } from 'react'
import {
  MDBModal,
  MDBModalHeader,
  MDBModalBody,
  MDBBtn,
  MDBModalDialog,
  MDBModalContent,
  MDBModalTitle,
} from 'mdb-react-ui-kit'
import { observer } from 'mobx-react-lite'
import ChangeRequestStore from './ChangeRequest.store'
import ChangeRequestForm from './ChangeRequestForm.component'

export default observer(({ userId }) => {
  const { initUser, enable, isLoading, isOpen } = ChangeRequestStore

  useEffect(() => {
    initUser(userId)
  }, [userId, initUser])

  if (!enable) return <></>

  return (
    <div id='ChangeRequestButtonComponent'>
      <MDBBtn
        type='button'
        disabled={isOpen || isLoading}
        className='btn-block'
        onClick={() => (ChangeRequestStore.isOpen = !isOpen)}
        sm='true'
        color='danger'
      >
        {isOpen ? 'Opening ...' : 'Request Upline or Commission Change'}
      </MDBBtn>
      <MDBModal open={isOpen} onClose={() => (ChangeRequestStore.isOpen = !isOpen)}>
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Agent Change Request Form</MDBModalTitle>
              <MDBBtn
                type='button'
                className='btn-close'
                color='none'
                onClick={() => (ChangeRequestStore.isOpen = !isOpen)}
              ></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <ChangeRequestForm />
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </div>
  )
})
